import { render, staticRenderFns } from "./splash.vue?vue&type=template&id=54612b12&"
import script from "./splash.vue?vue&type=script&lang=ts&"
export * from "./splash.vue?vue&type=script&lang=ts&"
import style0 from "./splash.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/компетенции.амур-иро.рф/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('54612b12', component.options)
    } else {
      api.reload('54612b12', component.options)
    }
    module.hot.accept("./splash.vue?vue&type=template&id=54612b12&", function () {
      api.rerender('54612b12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/splash.vue"
export default component.exports